import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

// Email confirmation link url from email will look like this: /email-confirmation/totp?token=<token>&user_id=<user_id>&token_type=email-confirmation
export const getEmailConfirmationValidateTotpPath = () => urlHelper('/email-confirmation/totp');
